import { getTrainingContent } from './trainingContent';

const BUSINESS_WHATSAPP = '237653459638';

const modeLabels = Object.freeze({
  fr: Object.freeze({ inPerson: 'Présentiel', online: 'En ligne' }),
  en: Object.freeze({ inPerson: 'In person', online: 'Online' }),
});

export function buildWhatsAppMessage({ locale, offer, mode }) {
  if (mode !== 'inPerson' && mode !== 'online') {
    throw new Error('Unsupported training mode');
  }

  const template = getTrainingContent(locale, offer.key).whatsappTemplate;
  const modeLabel = modeLabels[locale][mode];

  if (locale === 'fr') {
    return template.replace(
      'Je souhaite suivre la formation en {MODE}.',
      `Mode souhaité : ${modeLabel}.`,
    );
  }

  return template.replace('{MODE}', modeLabel);
}

export function buildWhatsAppUrl(input) {
  return `https://wa.me/${BUSINESS_WHATSAPP}?text=${encodeURIComponent(buildWhatsAppMessage(input))}`;
}
